import { Drawer, DrawerBody, DrawerTopBar, RoundedModal } from '@bridebook/aura';
import { IGuest } from '@bridebook/models/source/models/Weddings/Guests.types';
import { getScreenType } from '@bridebook/web/lib/app/selectors';
import { getGuests } from '@bridebook/web/lib/guestlist/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { useMemo } from 'react';
import { UpdateEmailForm } from './update-email-form';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  guest: IGuest | null;
  onEmailUpdated?: () => void;
}

export const UpdateEmailModal = ({ isOpen, onClose, guest, onEmailUpdated }: IProps) => {
  const guests = useSelector(getGuests);
  const { isMobile } = useSelector(getScreenType);

  const headGuest = useMemo(
    () => guests.find((_guest) => _guest.id === guest?.head),
    [guests, guest?.head],
  );

  if (!guest) {
    return null;
  }

  const handleEmailUpdated = () => {
    onEmailUpdated?.();
    onClose();
  };

  const handleOnOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  const formProps = {
    guest,
    headGuest,
    onEmailUpdated: handleEmailUpdated,
  };

  if (isMobile) {
    return (
      <Drawer isOpen={isOpen} onOpenChange={handleOnOpenChange}>
        <DrawerTopBar />
        <DrawerBody>
          <UpdateEmailForm {...formProps} variant="drawer" />
        </DrawerBody>
      </Drawer>
    );
  }

  return (
    <RoundedModal isOpen={isOpen} onOpenChange={handleOnOpenChange}>
      <UpdateEmailForm {...formProps} variant="modal" />
    </RoundedModal>
  );
};
